"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const or_1 = require("./or");
const isNone_1 = require("../predicates/isNone");
exports.maybe = (predicate) => or_1.or(predicate, isNone_1.isNone);
//# sourceMappingURL=maybe.js.map